/**
 * @Description: 用于存储产品模块中硬件产品，耗材的类型信息，比如连续型，模切型相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  MaterialTypeModel,
  MaterialTypeSearchModel,
  MaterialTypePageSearchModel,
  MaterialTypeAddModel,
  MaterialTypeUpdateModel,
  IdsModel
} from '@/model/product/MaterialTypeModel'

const baseUrl = Route.product + '/materialType'

/**
 * 搜索分页数据
 */
export const pageSearchMaterialType = (param: MaterialTypePageSearchModel) => {
  return https().request<RootObject<PageRespModel<MaterialTypeModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchMaterialType = (param: MaterialTypeSearchModel) => {
  return https().request<RootObject<MaterialTypeModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getMaterialType = (id: number) => {
  return https().request<RootObject<MaterialTypeModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addMaterialType = (param: MaterialTypeAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateMaterialType = (param: MaterialTypeUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeMaterialType = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveMaterialType = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
